import React, {useEffect} from 'react';
import './input.css';
import ConfigUpdater from "./components/ConfigUpdater";
import {Card, Link, Spinner} from "@nextui-org/react";
import {CirclePause} from "lucide-react";


const App: React.FC = () => {
    const [isPaused, setIsPaused] = React.useState<boolean>(false);
    const [isLoadingModel,setIsLoadingModel] = React.useState<boolean>(false);
    useEffect(() => {
        setInterval(()=>{
            try {
                window.pywebview.api.getAppPause().then((res: number)=>{
                    setIsPaused(res === 1);
                }).catch((e: any)=>console.log(e));
            }catch (e) {
                
            }
            try {
                window.pywebview.api.getModelExportingStatus().then((res: boolean)=>{
                    setIsLoadingModel(res);
                }).catch((e: any)=>console.log(e));
            }catch (e) {

            }
        },700)
    }, []);
    if(isLoadingModel){
        return <div className={'flex flex-col items-center justify-center h-screen w-screen overflow-x-hidden overflow-y-hidden'}>
            <p>Export model 5-15 min..</p>
            <Spinner className={'mt-2'}/>
        </div>
    }
    return (
        <div className="flex flex-col items-center">
            <Card className={'p-4 rounded-none flex justify-center items-center w-full'}>
                {isPaused && <p className={'text-danger flex items-center'}>On pause <CirclePause className={'ml-1'}/></p>}
                <div className={'flex items-center'} style={{cursor: 'pointer'}}>
                    <img src={'https://neurosk.pro/favicon.ico'} alt={'logo'} width={40} height={40}/>
                    <Link
                        target={"_blank"}
                        className={'ml-2 text-3xl md:text-8xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-l hover:from-green-400 hover:to-yellow-500 text-logo'}
                        href={'https://neurosk.vercel.app'}
                    >
                        NeuroSK
                    </Link>
                </div>
            </Card>
            <ConfigUpdater/>
        </div>
    );
};

export default App;
